import { createInjectionKey as e } from "../../_utils/vue/create-injection-key.js";
const o = e("n-message-api"), s = e("n-message-provider");
export {
  o as messageApiInjectionKey,
  s as messageProviderInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/message/src/context.js
// module id = 489
// module chunks = 67